import { DataListModel, WeGoAuthorizedLink, Permission, PermissionType } from './../../shared/config';
import { TranslateService } from './../../shared/translate/translate.service';
import { AuthService } from './../../shared/models/auth.service';
import { Component, OnInit, OnDestroy, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { WeGoConfig, IAPIResponse, IKeyValueInterface, ApplicationRouteURL } from '../../shared/config';
import { Location } from '@angular/common';
import { AdditionalFreeItemService } from '../models/additionalfreeitems.service';
import { AddtionalFreeItemModel } from '../models/additionalfreeitems.model';



@Component({
  selector: 'wego-additionalfreeitems-list',
  template: require('../views/additionalfreeitems-list.component.html'),
  providers: [AdditionalFreeItemService],
})
export class AdditionalFreeItemListComponent implements OnInit {
  DataListModel: DataListModel;
  additionalFreeItemList: AddtionalFreeItemModel[];
  apiErrorMsg: string;
  isLoading: boolean;

  message: string;
  urlDefaultPage: string;
  urlAdditionalFreeItemsUpdate: string;
  isMultipleDelete: boolean;
  private popupMsg: string;
  private module: string;
  private breadCrumbList: string;
  isParentCheck: boolean;
  additionalFreeItemMasterHashId: string;
  urlAdditionalFreeItemsAdd: string;
  addAdditionFreeItemsLink: WeGoAuthorizedLink;

  @ViewChild('successPopup') public successPopup: any;
  @ViewChild('childModal') public childModal: any;
  get isAnyChecked(): boolean {
    if (this.additionalFreeItemList) {
      let isCheck = this.additionalFreeItemList.some(x => x.isChecked == true);
      if (isCheck) {
        if (this.additionalFreeItemList.every(x => x.isChecked == true))
          this.isParentCheck = true;
        else
          this.isParentCheck = false;
      }
      else {
        this.isParentCheck = false;
      }

      return isCheck;
    }
    else {
      this.isParentCheck = false;
      return false;
    }
  }

  constructor(private additionalFreeItemService: AdditionalFreeItemService
    , private authService: AuthService
    , private router: Router, private translate: TranslateService) {
  }

  ngOnInit() {
    this.module = this.translate.instant('LblAdditionalFreeItems');
    this.DataListModel = this.authService.RetriveFilter(this.constructor.name);
    this.DataListModel.searchField = ["driverName", "subscriptionName", "sharedVehicleGroup", "dateAwaredDatetimeUTC", "createdDatetimeUTC","createdBy","type", "amount","organizationName"];
    this.urlDefaultPage = this.authService.GetURL(ApplicationRouteURL.URL_DEFAULT_PAGE);
    this.urlAdditionalFreeItemsUpdate = this.authService.GetURL(ApplicationRouteURL.URL_ADDITIONALFREEITEM_UPDATE);
    this.urlAdditionalFreeItemsAdd = this.authService.GetURL(ApplicationRouteURL.URL_ADDITIONALFREEITEM_ADD);
    this.GetAdditionalFreeItemList();
    this.breadCrumbList = this.translate.instant('LblListPage', [this.module]);
    this.addAdditionFreeItemsLink = new WeGoAuthorizedLink(this.urlAdditionalFreeItemsAdd, 
      Permission.PR_ADDITIONAL_FREE_ITEMS, PermissionType.INSERT,'btn btn-highlight navbar-right', 'LblAddNew');
  }

  public OnSort(sortName: string) {
    this.DataListModel.sortType = sortName;
    this.DataListModel.sortReverse = !this.DataListModel.sortReverse;
    this.GetAdditionalFreeItemList();
  }

  public OnSearch(event: any) {
    this.DataListModel = this.authService.GetSearchParameters(this.DataListModel, event.searchTerm, event.isReset);
    this.GetAdditionalFreeItemList();
  }

  public OnPageChanged(event: any): void {
    this.DataListModel.currentPage = event.page;
    this.GetAdditionalFreeItemList();
  };

  public OnPagingChange(event: any) {
    this.DataListModel.currentPage = 1;
    this.DataListModel.totalItems = 0;
    this.DataListModel.itemsPerPage = event.itemPerPage;
    this.GetAdditionalFreeItemList();
  }
  public OnExport(event: any) {
    this.isLoading = true;
    this.additionalFreeItemService.ExportAdditionalFreeItemsList(this.DataListModel)
      .subscribe(
      (res: any) => {
        if (res && res._body) {
          let fileName = "AdditionalFreeItems" + new Date().toISOString() + ".csv";
          this.authService.DownloadFile(fileName, res._body);
        }
        this.isLoading = false;
      },
      (error: any) => {
        this.apiErrorMsg = this.authService.HandleErrorStatusCode(error);
        this.isLoading = false;
      });
  }

  public GetAdditionalFreeItemList() {
    this.isLoading = true;
    this.additionalFreeItemService.GetAdditionalFreeItemsList(this.DataListModel)
      .subscribe(
      res => {
        this.additionalFreeItemList = res.data;
        this.DataListModel.totalItems = res.totalRecords;
        this.DataListModel.infoMessage = res.error;
        this.isLoading = false;
      },
      error => {
        this.apiErrorMsg = this.authService.HandleErrorStatusCode(error);
        this.isLoading = false;
      });
  }

  public OnParentCheck(isChecked: boolean) {
    this.additionalFreeItemList.forEach(x => x.isChecked = isChecked);
  }
  public DeleteAdditionalFreeItems(deleteAdditionalFreeItemsList: string[]) {
    this.isLoading = true;
    this.additionalFreeItemService.DeleteAdditionalFreeItemList(deleteAdditionalFreeItemsList)
      .subscribe(
      res => {
        this.DataListModel.currentPage = 1;
        this.GetAdditionalFreeItemList();
        this.popupMsg = this.translate.instant('LblRecordRemovedSuccess', [this.module]);
        this.ShowSuccessPopup();
      },
      error => {
        this.apiErrorMsg = this.authService.HandleErrorStatusCode(error);
        this.isLoading = false;
      });
  }
  public ShowChildModal(additionalFreeItemHashId?: string): void {
    if (additionalFreeItemHashId) {
      this.popupMsg = this.translate.instant('LblRecordDeleteConfirmation', [this.module]);
      this.isMultipleDelete = false;
      this.additionalFreeItemMasterHashId = additionalFreeItemHashId;
    }
    else {
      this.popupMsg = this.translate.instant('LblRecordMultiplDeleteConfirmation', [this.module]);
      this.isMultipleDelete = true;

    }
    this.childModal.show();
  }

  public HideChildModal(): void {
    this.childModal.hide();
  }

  public SuccessModalClick(): void {
    let deleteAdditinalFreeItemsList: any[];
    if (this.isMultipleDelete)
      deleteAdditinalFreeItemsList = this.additionalFreeItemList.filter(x => x.isChecked).map(x => x.additionalFreeItemMasterHashId);
    else
      deleteAdditinalFreeItemsList.push(this.additionalFreeItemMasterHashId);

    this.DeleteAdditionalFreeItems(deleteAdditinalFreeItemsList);
    this.childModal.hide();
  }

  public ShowSuccessPopup(): void {
    this.successPopup.show();
  }

  public HideSuccessPopup(): void {
    this.successPopup.hide();
  }

  public ConfirmSuccessPopup(): void {
    this.successPopup.hide();
  }
  ngOnDestroy() {
    this.authService.SetFilter(this.constructor.name, this.DataListModel);
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/additionalfreeitem/components/additionalfreeitems-list.component.ts